export function loadHookImage(image: string): string {
  return `assets/img/vendor/hooks/${image}.png`;
}
